<template>
  <main class="vh-100">
    <CardContainer :cardHeader="cardHeader" :cardFooter="cardFooter">
      <InputsContainer />
    </CardContainer>
  </main>
</template>
<script>
import { CardContainer } from "@/containers/exporter.js";
import InputsContainer from "./InputsContainer.vue";
export default {
  name: "main",
  data() {
    return {
      cardHeader: {
        title: "Sign In",
        subTitle: "Enter your email and password to Sign In.",
      },
      cardFooter: {
        paragraphText: "Forgot your password?",
        buttonText: "Forgot Password",
        buttonClick: () => {
          this.$router.push({ name: "Forgot Password" });
        },
      },
    };
  },
  components: {
    CardContainer,
    InputsContainer,
  },
};
</script>
